import styled from "styled-components";

export const Span = styled.span<{ size?: string; bold?: boolean; color?: string; center?: boolean }>`
  font-size: ${(p) => p.size ?? "12"}px;
  font-family: "Noto Sans", sans-serif;
  font-weight: ${(p) => (p.bold ? "bold" : "initial")};
  color: ${(p) => p.color ?? "initial"};
  text-align: ${(p) => (p.center ? "center" : "initial")};
`;
